// Reusable "TM" badge rendered as a hairline-gapped superscript. sizeEm controls text size.
export default function Tm({ sizeEm = 0.5, className = "" }) {
  return (
    <span
      aria-label="trade mark"
      className={`inline-block shrink-0 align-top font-bold text-amber-200 leading-none tracking-tighter ${className}`}
      style={{ marginLeft: "1px", fontSize: `${sizeEm * 0.75}em`, lineHeight: 1, verticalAlign: "0.9em" }}
    >
      TM
    </span>
  );
}
